export enum FileAuditionStatus {
  AllClear = "all_clear",
  AnomalyError = "anomaly_error",
  StorageError = "storage_error",
  FatalError = "fatal_error",
  ConnectionError = "connection_error",
}